module.exports = __webpack_public_path__ + "img/5.59208642.png";